import(/* webpackMode: "eager", webpackExports: ["RichText"] */ "/vercel/path0/apps/web/src/components/elements/rich-text.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SanityImage"] */ "/vercel/path0/apps/web/src/components/elements/sanity-image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TableOfContent"] */ "/vercel/path0/apps/web/src/components/elements/table-of-content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@sanity/next-loader/dist/client-components/live-stream.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@sanity/next-loader/dist/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-sanity/dist/visual-editing/client-component.js");
